<!-- Botones para cambiar de editor 2D a visor 3D -->
<div class="mode-switch">
	<button class="btn-2d" [class.selected]="currentViewMode === VIEW_MODE.MODE2D"
		[disabled]="!disabled2D" (click)="onModeChange(VIEW_MODE.MODE2D)">2D
	</button>
	<button class="btn-3d" [class.selected]="currentViewMode === VIEW_MODE.MODE3D"
		[disabled]="!readyForRender" (click)="onModeChange(VIEW_MODE.MODE3D)">3D
	</button>
</div>

<!-- Barra de herramientas -->
<div id="idToolBar" [hidden]="UIHidden()" class="app-tool-box2">
	<div class="app-tool-box2-header" (click)="handleState()" [class.disabled]="disabledToolBox">
		<i class="fa fa-angle-{{ minimizedToolBar ? 'right': 'left' }} fa-rotate-90"></i>
	</div>
	<!-- Iconos de las opciones -->
	<div class="app-tool-box2-contents">
		<!-- NO EDICION -->
		<button class="btn-app-tool-box2" [class.selected]="ModeDrag()" (click)="setDragMode();">
			<i class="fa fa-hand-paper-o fa-2x" alt="Movimiento de cámara"></i>
		</button>
		<!-- EDITAR -->
		<button class="btn-app-tool-box2" [hidden]="UIMinimize()" [class.selected]="ModeDraw()"	(click)="setDrawMode();">
			<i class="fa fa-pencil fa-2x"></i>
		</button>
		<!-- PUERTAS -->
		<button class="btn-app-tool-box2 png" [hidden]="UIMinimize()" [class.selected]="ModeDoor()"
			[disabled]="indexPerimeterSelected < 0" (click)="setDoorMode();">
			<img src="assets/img/door_w.png"alt="Añadir puerta" />
		</button>
		<!-- MUROS -->
		<button class="btn-app-tool-box2 png" [hidden]="UIMinimize()" [class.selected]="ModeElevation()"
			[disabled]="indexPerimeterSelected < 0" (click)="setStairMode();">
			<img src="assets/img/escalon_w.png" alt="Añadir elevacion" />
		</button>
		<div class="ruler" [hidden]="UIMinimize()"></div>
		<!-- DESHACER -->
		<button class="btn-app-tool-box2" [hidden]="UIMinimize()" [disabled]="!canHistorialBack()" (click)="clickUndo();">
			<i class="fa fa-reply fa-2x"></i>
		</button>
		<!-- REHACER -->
		<button class="btn-app-tool-box2" [hidden]="UIMinimize()" [disabled]="!canHistorialNext()" (click)="clickRedo();">
			<i class="fa fa-reply fa-2x fa-flip-horizontal"></i>
		</button>
		<div class="ruler" [hidden]="UIMinimize()"></div>
		<!-- BORRAR OBJETO -->
		<button class="btn-app-tool-box2" [hidden]="UIMinimize()" [class.selected]="ModeErase()"
			[disabled]="btnEraseAll()" (click)="setEraseMode();">
			<i class="fa fa-eraser fa-2x"></i>
		</button>
		<!-- BORRAR TODO -->
		<button class="btn-app-tool-box2" [hidden]="UIMinimize()" [disabled]="btnEraseAll()" (click)="drawEraseAllMode()">
			<i class="fa fa-trash fa-2x"></i>
		</button>
	</div>
</div>

<!-- Componente de configuración -->
<app-settingsbox #settingsBox
	*ngIf="currentViewMode === VIEW_MODE.MODE2D"
	[projectData]="projectData"
	[currentPerimeter]="getCurrentPerimeter()"
	[isDisabled]="projectData.estado > 0"
	(onSave)="saveToLocal()"
	(onDeleteDoor)="onProjectUpdate()"
	(refScreenShot)="refScreenShot()">
</app-settingsbox>

<!-- Botones ZOOM -->
<div id="idControlZoom" [hidden]="UIHidden()">
	<button class="btn-plus btnZoom" (click)="onZoomChange(-1)"><i class="fa fa-plus"></i></button>
	<button class="btn-less btnZoom" (click)="onZoomChange(1)"><i class="fa fa-minus"></i></button>
</div>

<!-- Botón ver detalle del proyecto (presupuesto) -->
<div class="app-see-box {{currentViewMode}} "
	[class.minimized]="isMinimized"
	[class.open]="!isMinimized">
	<div class="app-see-box-header" (click)="handleStateSee()">
		<i class="fa fa-angle-{{ isMinimized ? 'left': 'right' }}"></i>
	</div>
	<div class="app-see-box-contents">
		<button class="open-btn" [disabled]="!readyForRender" (click)="sendForAproval()">
			<span *ngIf="!isMinimized" class="label">
				{{ modelService.getString('builder_view_detail') }}</span>
			<i class="fa fa-eye fa-2x "></i>
		</button>
	</div>
</div>

<!-- Botón para cambiar a pantalla completa -->
<div id="idControlFullScreen" [hidden]="UIHidden()">
	<button class="btn-plus btnZoom" (click)="onToggleChange()">
		<i class="{{!fullscreen? 'fa fa-expand' : 'fa fa-compress'}}"></i>
	</button>
</div>

<!-- [ngClass]="currentViewMode === 'VIEW_MODE.MODE2D' ? 'show' : 'hide' " --> 
<app-scheme2 #Scheme2D
	*ngIf="currentViewMode === VIEW_MODE.MODE2D"
	(zoomChange)="onZoomChange2()"
	(change3Dto2D)="onChange3Dto2D()"
	(selectPerimeter)="onSelectPerimeter($event)"
	(actualizarToolBar)="onActualizarToolBar($event)"
	[projectData]="projectData"
	(changeLengthPerimeters)="onChangeLengthPerimeters($event)"
	(mueveGrid)="onChangeGrid($event)"
	[posicion]="posicionGrid">
</app-scheme2>

<!-- [ngClass]="currentViewMode === 'VIEW_MODE.MODE3D' ? 'hide' : 'show' " --><app-scheme3d 
*ngIf="currentViewMode === VIEW_MODE.MODE3D"
[projectData]="projectData"
(onStateRender)="onStateRender($event)"
[posicion] = "posicionGrid"
(mueveGrid)="onChangeGrid($event)"
></app-scheme3d>

<!-- Escala -->
<div *ngIf="currentViewMode === VIEW_MODE.MODE2D" class="canvasEscala">
	<label>1:10</label>
</div>

<div class="label-container canvas-width" *ngIf="currentViewMode === VIEW_MODE.MODE2D"
	[class.canvas-fullscreen]="fullscreen"
	[class.is--3d]="currentViewMode === VIEW_MODE.MODE3D">
	<span class="truncate-text">{{ modelService.getString('builder_canvas_width') }}</span>:
	<span class="value">{{ schemeSizeWidth }} m</span>
</div>

<div class="label-container canvas-height"
	*ngIf="currentViewMode === VIEW_MODE.MODE2D"
	[class.canvas-fullscreen]="fullscreen"
	[class.is--3d]="currentViewMode === VIEW_MODE.MODE3D">
	<span class="truncate-text">{{ modelService.getString('builder_canvas_height') }}</span>:
	<span class="value">{{ schemeSizeHeight }} m</span>
</div>

<div class="label-container total-distance"
	*ngIf="currentViewMode === VIEW_MODE.MODE2D"
	[class.canvas-fullscreen]="fullscreen"
	[class.is--3d]="currentViewMode === VIEW_MODE.MODE3D">
	<span class="truncate-text">{{ modelService.getString('builder_length') }}</span>: <span class="value"
		[class.error]="totalLengthErr" style="text-align:right">{{ totalLengthStr }} m</span>
</div>

<!--div id="idFooter" class="controlbar" *ngIf="!fullscreen">
	<div class="project-status">{{ modelService.getString('builde _status') }}:
		{{ projectData.estado.toString() | projectStatusPipe }}</div>
	<button class="btn btn-default" [disabled]="!readyForRender"
		(click)="send ForAproval()">{{ modelService.getString('builder_view_ detail') }}</button>
</div-->

<app-alert #alertWindow ></app-alert>